'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Call a handler once for each axis
function eachAxis(handler) {
  return [handler("x"), handler("y")];
}

exports.eachAxis = eachAxis;
